import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";
import Swal from "sweetalert2";
import "../assets/CSS/Dashboard.css";

export default function BoxPartyWise() {

  const API_BASE_URL = axiosInstance.defaults.baseURLPath;

  /* ================= USER ================= */
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = user?.EmployeeID || user?.id || "";
  const role = user?.Auth || "";

  const isKalim = userId === "1777" && role === "Admin";
  const isSwapnil = userId === "11" && role === "SuperAdmin";

  const isVendor = role === "Vendor";
  const isAdminUser = userId === "1021";
  const canSeeBrand = isKalim || isSwapnil || isAdminUser;

  /* ================= SIDEBAR ================= */
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  /* ================= DATA ================= */
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [kalimList, setKalimList] = useState([]);
  const [swapnilList, setSwapnilList] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [kalimSearch, setKalimSearch] = useState("");
  const [swapnilSearch, setSwapnilSearch] = useState("");
  const [vendorSearch, setVendorSearch] = useState("");

  const filterData = (data, searchText) => {
    return data.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  };

  const filteredKalim = filterData(kalimList, kalimSearch);
  const filteredSwapnil = filterData(swapnilList, swapnilSearch);
  const filteredVendor = filterData(vendorList, vendorSearch);

  /* ================= KPI ================= */
  const [kpi, setKpi] = useState({ total: 0, images: 0 });

  /* ================= UI ================= */
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (isAdminUser) setActiveTab("brand");
    else if (isKalim) setActiveTab("kalim");
    else if (isSwapnil) setActiveTab("swapnil");
    else setActiveTab("vendor");
  }, []);

  /* ================= MODAL ================= */
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState("");

  const [saving, setSaving] = useState(false);

  /* ================= IMAGE ================= */
  const MAX_IMAGES = 25;
  const [dragActive, setDragActive] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    newImages: []
  });

  const [existingImages, setExistingImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const [assignModal, setAssignModal] = useState(false);

  const [assignData, setAssignData] = useState({
    lotId: "",
    quantity: "",
    images: []
  });

  const openAssignModal = (row) => {
    setAssignData({
      lotId: row.LotID,
      quantity: "",
      images: []
    });
    setAssignModal(true);
  };

  const handleAssignImages = (files) => {
    setAssignData(prev => ({
      ...prev,
      images: [...prev.images, ...Array.from(files)]
    }));
  };

  const removeAssignImage = (index) => {
    setAssignData(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  const submitAssignVendor = async () => {
    try {

      if (!assignData.quantity) {
        return Swal.fire("Error", "Enter quantity", "warning");
      }

      const formData = new FormData();
      formData.append("lotId", assignData.lotId);
      formData.append("quantity", assignData.quantity);

      assignData.images.forEach(img => {
        formData.append("images", img);
      });

      await axiosInstance.post("/api/lot/assign-vendor", formData);

      Swal.fire("Success", "Assigned to Vendor", "success");

      setAssignModal(false);

      loadSwapnil();
      loadVendor();

    } catch {
      Swal.fire("Error", "Failed", "error");
    }
  };

  /* ================= FETCH ================= */

  const fetchData = async () => {
    setLoading(true);
    const res = await axiosInstance.get(`/api/box-party?page=${page}&limit=10&search=${search}`);
    setRecords(res.data.data || []);
    setLoading(false);
  };

  const loadKpi = async () => {
    const res = await axiosInstance.get("/api/box-party/kpi");
    setKpi({
      total: res.data.TotalParties || 0,
      images: res.data.TotalImages || 0
    });
  };

  const loadKalim = async () => {
    const res = await axiosInstance.get("/api/lot/kalim");
    setKalimList(res.data.data || []);
  };

  const loadSwapnil = async () => {
    const res = await axiosInstance.get("/api/lot/swapnil");
    setSwapnilList(res.data.data || []);
  };

  const loadVendor = async () => {
    const res = await axiosInstance.get("/api/lot/vendor");
    setVendorList(res.data.data || []);
  };

  /* ================= AUTO REFRESH ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      loadKalim();
      loadSwapnil();
      loadVendor();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchData();
    loadKpi();
    loadKalim();
    loadSwapnil();
    loadVendor();
  }, [page, search]);

  /* ================= IMAGE HANDLING ================= */

  const handleImageChange = (files) => {
    const newFiles = Array.from(files);

    if (formData.newImages.length + newFiles.length > MAX_IMAGES) {
      Swal.fire("Limit", `Max ${MAX_IMAGES} images`, "warning");
      return;
    }

    setFormData(prev => ({
      ...prev,
      newImages: [...prev.newImages, ...newFiles]
    }));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    handleImageChange(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => setDragActive(false);

  const removeNewImage = (index) => {
    setFormData(prev => ({
      ...prev,
      newImages: prev.newImages.filter((_, i) => i !== index)
    }));
  };

  const removeExistingImage = (img) => {
    setExistingImages(prev => prev.filter(i => i.ImageID !== img.ImageID));
    setDeletedImages(prev => [...prev, img.ImageID]);
  };

  /* ================= SAVE ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    try {
      setSaving(true);

      const data = new FormData();
      data.append("title", formData.title);
      data.append("deletedImages", JSON.stringify(deletedImages));

      formData.newImages.forEach(img => {
        data.append("images", img);
      });

      if (editMode) {
        await axiosInstance.put(`/api/box-party/${editingId}`, data);
      } else {
        await axiosInstance.post("/api/box-party", data);
      }

      Swal.fire("Success", "Saved", "success");

      resetForm();
      fetchData();
      loadKpi();

    } catch {
      Swal.fire("Error", "Failed", "error");
    } finally {
      setSaving(false);
    }
  };

  const resetForm = () => {
    setShowModal(false);
    setEditMode(false);
    setEditingId(null);
    setFormData({ title: "", newImages: [] });
    setExistingImages([]);
    setDeletedImages([]);
  };

  /* ================= EDIT ================= */

  const handleEdit = async (id) => {
    const res = await axiosInstance.get(`/api/box-party/${id}`);

    setEditMode(true);
    setEditingId(id);
    setSelectedTitle(res.data.party.Title);

    setFormData({
      title: res.data.party.Title,
      newImages: []
    });

    setExistingImages(res.data.images || []);
    setDeletedImages([]);

    setShowModal(true);
  };

  /* ================= VIEW ================= */

  const handleViewImages = async (id) => {
    const res = await axiosInstance.get(`/api/box-party/${id}`);
    setSelectedImages(res.data.images || []);
    setSelectedTitle(res.data.party.Title);
    setShowImageModal(true);
  };

  /* ================= STATUS ================= */

  const getStatusBadge = (status) => {
    let color = "secondary";

    if (status === "NEW SERIES") color = "warning";
    else if (status === "PO RAISED") color = "primary";
    else if (status === "SENT TO VENDOR") color = "info";
    else if (status === "COMPLETED") color = "success";

    return <span className={`badge p-2 bg-${color}`}>{status}</span>;
  };

  const updateStatus = async (type, lotId) => {
    try {
      await axiosInstance.post(`/api/lot/${type}`, { lotId });

      Swal.fire("Success", "Updated", "success");

      loadKalim();
      loadSwapnil();
      loadVendor();

    } catch {
      Swal.fire("Error", "Failed", "error");
    }
  };

  const trackingColumns = [
    { name: "Lot ID", selector: row => row.LotID },
    { name: "Status", cell: row => getStatusBadge(row.Status) },
    {
      name: "Action",
      cell: row => {
        const canRaisePO = (
          row.Status === "COMPLETED" || row.PhotoFound === true
        ) && row.Status !== "PO RAISED";
        return (
        <div className="d-flex gap-2">
          {canRaisePO && (
            <button className="btn btn-sm btn-primary"
              onClick={() => updateStatus("po-raised", row.LotID)}>
              PO Raised
            </button>
          )}

          {row.PhotoFound === false && row.Status === "PHOTO NOT FOUND" && (
            <button
              className="btn btn-sm btn-warning"
              onClick={() => openAssignModal(row)}
            >
              Assign Vendor
            </button>
          )}

          {row.Status === "SENT TO VENDOR" && (
            <button className="btn btn-sm btn-success"
              onClick={() => updateStatus("vendor-complete", row.LotID)}>
              Complete
            </button>
          )}
        </div>
        )
      } 
    }
  ];

  const columns = [
    {
      name: "Brand Name",
      cell: row => (
        <span
          style={{ color: "#0d6efd", cursor: "pointer", fontWeight: "600" }}
          onClick={() => handleViewImages(row.PartyID)}
        >
          {row.Title}
        </span>
      )
    },
    {
      name: "Action",
      cell: row => (
        <button className="btn btn-sm btn-outline-primary"
          onClick={() => handleEdit(row.PartyID)}>
          Edit
        </button>
      )
    }
  ];

  const vendorColumns = [
    { name: "Lot ID", selector: row => row.LotID },

    { name: "Brand", selector: row => row.Brand || "-" },

    { name: "Quantity", selector: row => row.VendorQty || "-" },

    {
      name: "Sample Photos",
      cell: row => {
        let photos = [];

        try {
          photos = JSON.parse(row.SamplePhotos || "[]");
        } catch {}

        return (
          <div className="d-flex gap-2 flex-wrap">
            {photos.length > 0 ? photos.map((img, i) => (
              <img
                key={i}
                src={`${API_BASE_URL}/${img.replace(/\\/g, "/")}`}
                style={{
                  width: 50,
                  height: 50,
                  objectFit: "cover",
                  borderRadius: 5,
                  cursor: "pointer"
                }}
                onClick={() => window.open(`${API_BASE_URL}/${img}`, "_blank")}
              />
            )) : <span>-</span>}
          </div>
        );
      }
    },

    {
      name: "Status",
      cell: row => getStatusBadge(row.Status)
    },

    {
      name: "Action",
      cell: row => (
        <button
          className="btn btn-sm btn-success"
          onClick={() => updateStatus("vendor-complete", row.LotID)}
        >
          Order Completed
        </button>
      )
    }
  ];

  /* ================= UI ================= */

  return (
    <div className="d-flex dashboard">

      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />

        <main className="main-container p-4">

          <h3 className="mb-4">Box Party Wise Dashboard</h3>

          <div className="row mb-4">
            <div className="col-md-6">
              <div className="card text-center p-3 shadow-sm">
                <h6>Total Parties</h6>
                <h3>{kpi.total}</h3>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card text-center p-3 shadow-sm">
                <h6>Total Images</h6>
                <h3>{kpi.images}</h3>
              </div>
            </div>
          </div>

          <div className="card shadow-sm">

            <div className="card-header bg-white">
              <ul className="nav nav-pills">

                {/* Brand → only Kalim & Swapnil */}
                {canSeeBrand && (
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "brand" ? "active" : ""}`}
                      onClick={() => setActiveTab("brand")}
                    >
                      Brand Library
                    </button>
                  </li>
                )}

                {/* Kalim */}
                {(isKalim || isAdminUser) && (
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "kalim" ? "active" : ""}`}
                      onClick={() => setActiveTab("kalim")}
                    >
                      Lot Processing
                    </button>
                  </li>
                )}

                {/* Swapnil */}
                {(isSwapnil || isAdminUser) && (
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "swapnil" ? "active" : ""}`}
                      onClick={() => setActiveTab("swapnil")}
                    >
                      Quality Check / Review
                    </button>
                  </li>
                )}

                {/* VENDOR → all user if vendor */}
                {(isVendor || isAdminUser) && (
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "vendor" ? "active" : ""}`}
                      onClick={() => setActiveTab("vendor")}
                    >
                      Vendor Assignment
                    </button>
                  </li>
                )}

              </ul>
            </div>

            <div className="card-body">
              {/* BRAND */}
              {canSeeBrand && activeTab === "brand" && (
                <>
                  <div className="d-flex justify-content-between mb-3">
                    <input
                      className="form-control"
                      placeholder="Search..."
                      style={{ width: 250 }}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />

                    <button className="btn btn-primary" onClick={() => setShowModal(true)}>
                      + Add Brand
                    </button>
                  </div>

                  <DataTable columns={columns} data={records} pagination />
                </>
              )}

              {/* KALIM */}
              {(isKalim || isAdminUser) && activeTab === "kalim" && (
                <>
                  <input
                    className="form-control mb-2"
                    placeholder="Search..."
                    value={kalimSearch}
                    onChange={(e) => setKalimSearch(e.target.value)}
                    style={{ width: 250 }}
                  />

                  <DataTable columns={trackingColumns} data={filteredKalim} pagination />
                </>
              )}
              
              {/* SWAPNIL */}
              {(isSwapnil || isAdminUser) && activeTab === "swapnil" && (
                <>
                  <input
                    className="form-control mb-2"
                    placeholder="Search..."
                    value={swapnilSearch}
                    onChange={(e) => setSwapnilSearch(e.target.value)}
                    style={{ width: 250 }}
                  />

                  <DataTable columns={trackingColumns} data={filteredSwapnil} pagination />
                </>
              )}

              {/* VENDOR → all user if vendor */}
              {(isVendor || isAdminUser) && activeTab === "vendor" && (
                <>
                  <input
                    className="form-control mb-2"
                    placeholder="Search..."
                    value={vendorSearch}
                    onChange={(e) => setVendorSearch(e.target.value)}
                    style={{ width: 250 }}
                  />

                  <DataTable columns={vendorColumns} data={filteredVendor} pagination />
                </>
              )}

            </div>
          </div>

        </main>
      </div>

      {/* ================= ADD / EDIT MODAL ================= */}

      {showModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block">
            <div className="modal-dialog modal-lg">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5>{editMode ? `Edit Brand Party :: ${selectedTitle}` : "Add Brand"}</h5>
                  <button className="btn-close" onClick={resetForm}></button>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="modal-body">

                    <div className="mb-3">
                      <label>Brand Name</label>
                      <input
                        className="form-control"
                        required
                        value={formData.title}
                        onChange={(e) =>
                          setFormData({ ...formData, title: e.target.value })
                        }
                      />
                    </div>

                    {/* <div className="mb-3">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        value={formData.description}
                        onChange={(e) =>
                          setFormData({ ...formData, description: e.target.value })
                        }
                      />
                    </div> */}

                    {/* Drag Drop */}
                    <div
                      className={`border rounded p-4 text-center ${
                        dragActive ? "bg-light border-primary" : ""
                      }`}
                      style={{ borderStyle: "dashed", cursor: "pointer" }}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onClick={() => document.getElementById("boxImageInput").click()}
                    >
                      <h6>Drag & Drop Images Here</h6>
                      <div className="text-muted">or click to browse</div>

                      <input
                        id="boxImageInput"
                        type="file"
                        multiple
                        accept="image/*"
                        hidden
                        onChange={(e) => handleImageChange(e.target.files)}
                      />

                      <div className="mt-2 text-muted">
                        Max {MAX_IMAGES} images
                      </div>
                    </div>

                    {/* Existing Images */}
                    {editMode && existingImages.length > 0 && (
                      <>
                        <h6 className="mt-3">Existing Images</h6>
                        <div className="row">
                          {existingImages.map((img, i) => (
                            <div className="col-md-3 mb-3" key={i}>
                              <div className="position-relative">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute"
                                  style={{ top: 5, right: 5 }}
                                  onClick={() => removeExistingImage(img)}
                                >
                                  ✕
                                </button>

                                <img
                                  src={`${API_BASE_URL}/${img.ImagePath.replace(/\\/g, "/")}`}
                                  className="img-fluid rounded"
                                  style={{ height: 120, objectFit: "cover" }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {/* New Images */}
                    {formData.newImages.length > 0 && (
                      <>
                        <h6 className="mt-3">New Images</h6>
                        <div className="row">
                          {formData.newImages.map((file, index) => (
                            <div className="col-md-3 mb-3" key={index}>
                              <div className="position-relative">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute"
                                  style={{ top: 5, right: 5 }}
                                  onClick={() => removeNewImage(index)}
                                >
                                  ✕
                                </button>

                                <img
                                  src={URL.createObjectURL(file)}
                                  className="img-fluid rounded"
                                  style={{ height: 120, objectFit: "cover" }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                  </div>

                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn-success d-flex align-items-center"
                      disabled={saving}
                    >
                      {saving && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      )}

                      {saving ? "Saving..." : editMode ? "Update" : "Save"}
                    </button>

                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                      Cancel
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ================= VIEW IMAGES MODAL ================= */}

      {showImageModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block">
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>Party Images :: {selectedTitle}</h5>
                  <button className="btn-close" onClick={() => setShowImageModal(false)}></button>
                </div>

                <div className="modal-body row">
                  {selectedImages.map((img, i) => (
                    <div className="col-md-3 mb-3" key={i}>
                      <img
                        src={`${API_BASE_URL}/${img.ImagePath.replace(/\\/g, "/")}`}
                        className="img-fluid rounded"
                        style={{ height: 200, objectFit: "cover" }}
                      />
                    </div>
                  ))}
                </div>

              </div>
            </div>
          </div>
        </>
      )}

      {/* ================= ASSIGNED VENDOR MODAL ================= */}
      {assignModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block">
            <div className="modal-dialog modal-lg">
              <div className="modal-content shadow">

                <div className="modal-header">
                  <h5>Assign Vendor</h5>
                  <button className="btn-close" onClick={() => setAssignModal(false)}></button>
                </div>

                <div className="modal-body">

                  <div className="mb-2">
                    <label>Lot ID</label>
                    <input className="form-control" value={assignData.lotId} disabled />
                  </div>

                  <div className="mb-2">
                    <label>Required Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={assignData.quantity}
                      onChange={(e) =>
                        setAssignData({ ...assignData, quantity: e.target.value })
                      }
                    />
                  </div>

                  <div className="mb-3">
                    <label>Sample Photos</label>
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      onChange={(e) => handleAssignImages(e.target.files)}
                    />
                  </div>

                  {/* Preview */}
                  {assignData.images.length > 0 && (
                    <div className="row">
                      {assignData.images.map((img, i) => (
                        <div className="col-md-3 mb-3" key={i}>
                          <div className="position-relative">

                            <button
                              className="btn btn-sm btn-danger position-absolute"
                              style={{ top: 5, right: 5 }}
                              onClick={() => removeAssignImage(i)}
                            >
                              ✕
                            </button>

                            <img
                              src={URL.createObjectURL(img)}
                              className="img-fluid rounded"
                              style={{ height: 120, objectFit: "cover" }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                </div>

                <div className="modal-footer">
                  <button className="btn btn-success" onClick={submitAssignVendor}>
                    Submit
                  </button>

                  <button className="btn btn-secondary" onClick={() => setAssignModal(false)}>
                    Cancel
                  </button>
                </div>

              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
}